"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Play = void 0;
const react_1 = __importStar(require("react"));
const shared_hooks_use_boolean_1 = require("@guidde-co/shared.hooks.use-boolean");
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const PlayArrow_1 = __importDefault(require("@material-ui/icons/PlayArrow"));
const Pause_1 = __importDefault(require("@material-ui/icons/Pause"));
exports.Play = (0, react_1.memo)(({ videoElement }) => {
    const stopped = (0, shared_hooks_use_boolean_1.useBoolean)(videoElement ? videoElement.paused : true);
    const play = () => {
        if (!videoElement)
            return;
        videoElement.play();
    };
    const pause = () => {
        if (!videoElement)
            return;
        videoElement.pause();
    };
    (0, react_1.useEffect)(() => {
        if (!videoElement)
            return;
        videoElement.addEventListener('playing', stopped.setFalse);
        videoElement.addEventListener('pause', stopped.setTrue);
        return () => {
            videoElement.removeEventListener('playing', stopped.setFalse);
            videoElement.removeEventListener('pause', stopped.setTrue);
        };
    }, [videoElement, stopped.setTrue, stopped.setFalse]);
    return (react_1.default.createElement(Box_1.default, { mr: 1.5, display: "flex", alignItems: "center", justifyContent: "center" }, stopped.isTrue ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IconButton_1.default, { onClick: play, size: "small", disableRipple: true, style: { color: 'white' } },
            react_1.default.createElement(PlayArrow_1.default, { fontSize: "small" })))) : (react_1.default.createElement(IconButton_1.default, { onClick: pause, size: "small", disableRipple: true, style: { color: 'white' } },
        react_1.default.createElement(Pause_1.default, { fontSize: "small" })))));
});
//# sourceMappingURL=play.js.map